<app-spinner></app-spinner>
<div class="content">
  <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12" style="padding: 10px">
    <mat-card>
      <div style="margin-top: 1%; margin-left: 1%">
        <mat-form-field appearance="outline" style="width: 13%">
          <mat-label>Search Name</mat-label>
          <input
            matInput
            type="text"
            (keyup)="apiGroupFilter($event.target.value)"
          />
        </mat-form-field>
        <div
          style="float: right; padding: 10px"
          mat-raised-button
          color="blue "
          class="pointer"
          (click)="createGroup()"
          mat-flat-button
        >
          <img
            src="assets/img/icons/group-31.png"
            matTooltip="Add"
            matTooltipPosition="left"
          />
        </div>
      </div>

      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="mat-elevation-z8"
        style="width: 100%"
      >
        <ng-container matColumnDef="apiGroupId ">
          <th mat-header-cell *matHeaderCellDef>Id</th>
          <td mat-cell *matCellDef="let element">{{ element.apiGroupId }}</td>
        </ng-container>

        <ng-container matColumnDef="Sno">
          <th mat-header-cell *matHeaderCellDef>S.No</th>
          <td mat-cell *matCellDef="let element">
            {{ dataSource.filteredData.indexOf(element) + 1 }}
          </td>
        </ng-container>

        <ng-container matColumnDef="name" style="width: 50%">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef>Edit</th>
          <td mat-cell *matCellDef="let element" class="pointer">
            <img
              src="assets/img/icons/forma-1-copy-2.png"
              matTooltip="Edit"
              matTooltipPosition="left"
              (click)="editapiGroup(element.groupId)"
            />
          </td>
        </ng-container>
        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef>Delete</th>
          <td
            mat-cell
            *matCellDef="let element; let i = i; ndex"
            class="pointer"
          >
            <img
              src="assets/img/icons/forma-1.png "
              matTooltip="Delete"
              matTooltipPosition="left"
              (click)="deleteGroup(element.groupId)"
            />
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedcolumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedcolumns"></tr>
      </table>
      <mat-paginator
        [pageSizeOptions]="[10, 20, 100]"
        showFirstLastButtons
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        (page)="handlePage($event)"
      ></mat-paginator>
    </mat-card>
  </div>
</div>
